import { Settings } from '../../api/settings'
import { ButtonAnchor, Button, Panel } from '../../components/common'
import { useNavigateTo } from '../../lib/spaPath'
import styles from './SettingsPage.module.scss'

const PLAN_NAMES: Readonly<Record<string, string>> = {
  personal: 'Plan Premium Personal',
  custom: 'Plan Premium Personalizado',
  center5: 'Plan Premium 5 profesionales',
  center10: 'Plan Premium 10 profesionales',
  center15: 'Plan Premium 15 profesionales',
  center20: 'Plan Premium 20 profesionales',
}

function _getPlanName(plan: Settings['plan']): string {
  return plan.freemium ? 'Plan Gratuito' : (PLAN_NAMES[plan.payment_plan] ?? '')
}

function _getRemainingDaysMessage(closeDay: number): string {
  const remaining = closeDay - new Date().getDate()
  return remaining > 1
    ? `Quedan ${remaining} días para realizar tu pago`
    : '¡Hoy es el último día! Si no pagas hoy, mañana se cancelará tu cuenta'
}

export function PlanPanel({ settings, onNavigate }: { settings: Settings; onNavigate: (run: () => void) => void }) {
  const { plan, paths } = settings
  const buttonLabel = plan.freemium ? 'Subir a premium' : 'Realizar pago'
  const navigateTo = useNavigateTo()

  return (
    <Panel className={styles.sidePanel}>
      <div className={`well ${styles.well}`}>
        <div className="row">
          <h3 className="text-center blue-subtitle">
            <p>{_getPlanName(plan)}</p>
            {plan.soon && (
              <p className={`warning-text ${styles.planState}`}>
                <i className="fa fa-exclamation-triangle" /> (Pago pendiente)
              </p>
            )}
            {plan.closed && (
              <p className={`danger-text ${styles.planState}`}>
                <i className="fa fa-exclamation-triangle" /> (Cuenta desactivada)
              </p>
            )}
          </h3>

          <div className={`col-md-12 ${styles.planBody}`}>
            <p className={styles.centered}>
              {plan.freemium && '¿Quieres actualizar a premium?'}
              {!plan.freemium && plan.open && (
                <>
                  <p className={styles.centered}>
                    Tu plan se encuentra activo <a href={paths.new_payment}>(mejorar)</a>
                  </p>
                  {plan.latest_payment && (
                    <p className={styles.centered}>
                      {`Periodo último pago: ${plan.latest_payment.begin_date} - ${plan.latest_payment.end_date}`}
                    </p>
                  )}
                </>
              )}
              {!plan.freemium && plan.soon && _getRemainingDaysMessage(plan.payment_close_day)}
              {!plan.freemium && plan.closed && 'Tu cuenta se encuentra cerrada'}
            </p>
          </div>

          <div className={`col-md-12 ${styles.planActions}`}>
            {plan.has_current_paid_payment ? (
              <>
                <Button variant="default" block className="btn-payment" disabled>
                  {buttonLabel}
                </Button>
                <p>Ya se ha pagado el periodo actual</p>
              </>
            ) : (
              <ButtonAnchor
                href={paths.new_payment}
                block
                className="btn-payment"
                onClick={(event) => {
                  event.preventDefault()
                  onNavigate(() => navigateTo(paths.new_payment))
                }}
              >
                {buttonLabel}
              </ButtonAnchor>
            )}
          </div>

          <div className="col-xs-12">
            <a href={paths.payments} className={styles.underlinedLink}>
              Ver historial de pagos
            </a>
          </div>
          {paths.certificate_of_use && (
            <div className="col-xs-12">
              <a href={paths.certificate_of_use} className={styles.underlinedLink}>
                Descargar certificado de uso
              </a>
            </div>
          )}
        </div>
      </div>
    </Panel>
  )
}
